var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      staticClass: "mass-operations-sidesheet",
      attrs: { id: "type-modal", active: _vm.displayModal },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingData,
              expression: "!isLoadingData",
            },
          ],
          staticClass: "modal-frame",
        },
        [
          _c(
            "div",
            { staticClass: "modal-wrapper" },
            [
              _c(
                "shadow-scroll-container",
                {
                  ref: "track",
                  staticClass: "modal-track",
                  attrs: { "with-top-scroller": true },
                },
                [
                  _c("div", { staticClass: "modal-track__wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "modal-frame__header" },
                      [
                        _c("h2", { staticClass: "modal-frame__title" }, [
                          _vm._v("Исполнители"),
                        ]),
                        _c("c-input", {
                          staticClass: "modal-frame__list-search",
                          attrs: {
                            placeholder: "Поиск по ФИО",
                            clearable: true,
                            icon: "search",
                          },
                          on: { enter: _vm.updateList },
                          model: {
                            value: _vm.search,
                            callback: function ($$v) {
                              _vm.search = $$v
                            },
                            expression: "search",
                          },
                        }),
                        _vm.workers.length
                          ? _c("div", { staticClass: "modal-frame__info" }, [
                              _c(
                                "div",
                                { on: { click: _vm.changeCheckboxAll } },
                                [
                                  _c("c-switcher", {
                                    staticClass: "modal-frame__checkbox",
                                    attrs: {
                                      label: "Выбрать всех",
                                      type: "checkbox",
                                      middlePosition:
                                        _vm.middlePositioncheckboxAll,
                                    },
                                    model: {
                                      value: _vm.checkboxAll,
                                      callback: function ($$v) {
                                        _vm.checkboxAll = $$v
                                      },
                                      expression: "checkboxAll",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "modal-frame__counter" },
                                [
                                  _c("span", [_vm._v("Выбрано:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.checkedWorkersCounter) +
                                      " из " +
                                      _vm._s(_vm.workersTotalCount)
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "modal-frame__list" },
                      [
                        _vm._l(_vm.workers, function (worker) {
                          return _c(
                            "div",
                            {
                              key: worker.id,
                              staticClass: "modal-frame__worker",
                            },
                            [
                              _c("c-switcher", {
                                staticClass: "modal-frame__checkbox",
                                attrs: { type: "checkbox" },
                                model: {
                                  value: worker.checked,
                                  callback: function ($$v) {
                                    _vm.$set(worker, "checked", $$v)
                                  },
                                  expression: "worker.checked",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" },
                                  ],
                                  staticClass: "modal-frame__worker-photo",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "svg-wrapper" },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          name: "eye",
                                          size: 32,
                                          color: "white",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: `${
                                        worker.photo
                                          ? worker.photo
                                          : "/redesign/img/userpic.svg"
                                      }`,
                                      width: "34",
                                      height: "34",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "modal-frame__worker-text" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "modal-frame__worker-name" },
                                    [_vm._v(_vm._s(worker.fio))]
                                  ),
                                  _vm._l(worker.posts, function (post) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-frame__worker-posts",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            post.typePost_name +
                                              " / " +
                                              post.post_name +
                                              " / " +
                                              post.specialty_name +
                                              " / " +
                                              post.rank_number
                                          )
                                        ),
                                      ]
                                    )
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "modal-frame__worker-filial",
                                    },
                                    [_vm._v(_vm._s(worker.filial_name))]
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        }),
                        !_vm.workers.length
                          ? _c(
                              "div",
                              { staticClass: "modal-frame__list-empty" },
                              [
                                _vm._v(
                                  " Нет исполнителей с заданными параметрами "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.isLoadingData || _vm.isLoading
                          ? _c("c-loader", {
                              attrs: {
                                label: "Данные загружаются",
                                active: _vm.isLoadingData || _vm.isLoading,
                                height: "400",
                              },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "modal-frame__actions",
                            class: {
                              "modal-frame__actions--fixed": _vm.actionsIsFixed,
                            },
                          },
                          [
                            _c("c-button", {
                              staticClass: "modal-frame__action",
                              attrs: { label: "Отменить", size: "large" },
                              on: { click: _vm.close },
                            }),
                            _c("c-button", {
                              staticClass: "modal-frame__action",
                              attrs: {
                                label: "Сохранить",
                                size: "large",
                                color: "primary",
                              },
                              on: { click: _vm.submit },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          !_vm.isLoadingData && _vm.displayModal
            ? _c("display-shown-items-count", {
                attrs: {
                  "total-items-count": _vm.workersTotalCount,
                  "shown-items-count": _vm.workers.length,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }